import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TCertification } from "../types";

type CertCallbacks = { onSuccess?: (res: any) => void; onError?: (err: any) => void };

export const useCertificationList = () => {
  return useQuery({
    queryKey: [API_ENDPOINTS.CERTIFICATIONS],
    queryFn: () => client.get(`${API_ENDPOINTS.CERTIFICATIONS}list`),
    select: (res: any) => res.data.data as TCertification[],
    refetchOnWindowFocus: false,
  });
};

export const useCertificationCreate = ({ onSuccess, onError }: CertCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<TCertification>) => client.post(`${API_ENDPOINTS.CERTIFICATIONS}create`, data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.CERTIFICATIONS] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};

export const useCertificationUpdate = ({ onSuccess, onError }: CertCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: number } & Partial<TCertification>) =>
      client.put(API_ENDPOINTS.CERTIFICATION_UPDATE(id), data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.CERTIFICATIONS] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};

export const useCertificationDelete = ({ onSuccess, onError }: CertCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.delete(API_ENDPOINTS.CERTIFICATION_DELETE(id)),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.CERTIFICATIONS] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};
